import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDBadge from "components/MDBadge";

export default function data({ model, deleteEvent, detailEvent, paymentEvent }) {
  model = model ?? [];

  const Overall = ({ name, id, organizationName, status }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      <div>
        <button code={"btnDetail" + id} onClick={() => detailEvent(`${id}`)}
          style={{ border: 0, backgroundColor: 'transparent' }}>
          <MDBadge
            badgeContent="Xem"
            color="info"
            variant="gradient"
            size="sm"
          />
        </button>
        <div style={{ height: 4 }} />
        {status !== 'PAID' && <>
          <button code={"btnPayment" + id} onClick={() => paymentEvent(`${id}`)}
            style={{ border: 0, backgroundColor: 'transparent' }}>
            <MDBadge
              badgeContent="Thanh toán"
              color="success"
              variant="gradient"
              size="sm"
            />
          </button>
          <div style={{ height: 4 }} /></>}
        <button
          style={{ border: 0, backgroundColor: 'transparent' }}
          code={"btnDelete" + id}
          onClick={() => {
            deleteEvent(`${id}`);
          }}
        >
          <MDBadge
            badgeContent="Xóa"
            color="warning"
            variant="gradient"
            size="sm"
          />
        </button>
      </div>
      <MDBox ml={2} lineHeight={1}>
        <MDTypography display="block" variant="button" fontWeight="medium">
          {name}
        </MDTypography>
        <MDTypography variant="caption">{id}</MDTypography><br />
        <MDTypography variant="caption"><i><b>{organizationName}</b></i></MDTypography><br />
        <MDTypography variant="caption"><b>{status === 'PAID' ? 'Đã thanh toán' : 'Chưa thanh toán'}</b></MDTypography>
      </MDBox>
    </MDBox>
  );

  const RowItem = ({ value }) => (
    <MDBox lineHeight={1} textAlign="left">
      <MDTypography variant="caption">{value}</MDTypography>
    </MDBox>
  );

  const rows = [];

  model.forEach((item) => {
    rows.push({
      overall: <Overall name={item.name} organizationName={item.organizationName} status={item.paymentStatus} id={item.id ?? 0} />,
      description: <RowItem description={item.description} />
    });
  });

  return {
    columns: [
      { Header: "Mục", accessor: "overall", width: "45%", align: "left" },
      { Header: "Mô tả", accessor: "description", align: "left" },
    ],
    rows: rows,
  };
}
